//#region Namespace
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit,Input,EventEmitter,Output,ChangeDetectorRef } from '@angular/core';
//import { e } from '@angular/core/src/render3';
//import { Console } from 'console';

import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
import { ToastrService } from "ngx-toastr";
import {
  ContentManagementService,
  ICreateUpdateStudyUnitPayload,
} from 'src/app/Services/content-management/content-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
//import { number } from 'ngx-custom-validators/src/app/number/validator';

//#endregion
@Component({
  selector: 'app-subject-relocate',
  templateUrl: './subject-relocate.component.html',
  styleUrls: ['./subject-relocate.component.css'],
})
export class SubjectRelocateComponent implements OnInit {
  @Input() FromWhichComponent: string;
  @Input() StudyUnit: ICreateUpdateStudyUnitPayload;
  @Input() SubjectParentInput: any;
  @Input() Refresh: any;
  @Input() MajorTopic: any;
  @Input() subjectParentEnable: boolean;
  @Output() cancelSubjectParentChange: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() onSubjectParentChangeSucces: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() closeAddEditElement: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private cdr: ChangeDetectorRef,
    public service: SubjectManagmentService,
    public toast: ToastrService,
    private contentService: ContentManagementService
  ) {}

  selectedsubject: any;
  subject: any;
  currentsubject: any;
  ngOnInit() {
    if (Number(this.SubjectParentInput.Subject_Id) > 0) {
      this.service
        .getsubjectById({
          CurrentNodeSubjectID: Number(this.SubjectParentInput.Subject_Id),
        })
        .subscribe(
          (i: any) => {
            this.currentsubject = i;
            // }).catch((e:any)=> {return null;})
          },
          (error: any) => {
            console.log(error);
          }
        );
      this.service
        .getBreadcrumbDetails({
          ID: Number(this.SubjectParentInput.Subject_Id),
        })
        .subscribe(
          (i: any) => {
            let routnodes: any = i;
            routnodes.forEach((i: any) => {
              if (i.Subject_Level_Type_Code === 'S') {
                this.SubjectParentInput.Selected_Header_ID = Number(
                  i.Subject_ID
                );
                this.SubjectParentInput.Parent_Subject_Id = Number(
                  i.Subject_ID
                );
                this.getsubjectbyid(i.Subject_ID);
              }
            });
            // }).catch((e:any)=>{});}
          },
          (error: any) => {
            console.log(error);
          }
        );
    }
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  ngOnChanges() {
    console.log(this.SubjectParentInput, 'SubjectParentInput');
    console.log(this.Refresh, 'Refresh');
    console.log(this.MajorTopic, 'MajorTopic');
    console.log(this.subjectParentEnable, 'subjectParentEnable');
    console.log(this.StudyUnit, 'studyUnit Payload');
  }
  Breadcrumblist: any;
  previousNode: any;
  getsubjectbyid(id: number): any {
    this.service.getsubjectById({ CurrentNodeSubjectID: Number(id) }).subscribe(
      (i: any) => {
        this.Breadcrumblist = null;
        this.getBreadcrumbDetails(id);
        this.subject = i;
        if (i.Subject_Level_Type_Code == 'S') {
          this.getsubject('S', { ID: Number(i.Subject_Id) }, null);
        }
        // }).catch((e:any)=> {return null;})
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  majorTopic: any;
  concept: any;
  subconcept1: any;
  subconcept2: any;
  subconcept3: any;
  subconcept4: any;
  subconcept5: any;
  subconcept6: any;
  mdl_subject: any = 0;
  mdl_majorTopic: any = 0;
  mdl_concept: any = 0;
  mdl_subconcept1: any = 0;
  mdl_subconcept2: any = 0;
  mdl_subconcept3: any = 0;
  mdl_subconcept4: any = 0;
  mdl_subconcept5: any = 0;
  mdl_subconcept6: any = 0;
  getsubject(key: string, value: any, data: any) {
    try {
      if (data && key != 'S') {
        if (data.ChildNodeExistInd === 'N') {
          if (key == 'MT' && data.ChildNodeExistInd === 'N') {
            this.majorTopic = null;
            this.concept = null;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_majorTopic = 0;
            this.mdl_concept = 0;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'C' && data.ChildNodeExistInd === 'N') {
            this.concept = null;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_concept = 0;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC1' && data.ChildNodeExistInd === 'N') {
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC2' && data.ChildNodeExistInd === 'N') {
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC3' && data.ChildNodeExistInd === 'N') {
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC4' && data.ChildNodeExistInd === 'N') {
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC5' && data.ChildNodeExistInd === 'N') {
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC6' && data.ChildNodeExistInd === 'N') {
            this.subconcept6 = null;
            this.mdl_subconcept6 = 0;
          }
          return;
        }
      }
    } catch {}
    if (key != '' && Number(value.ID) > 0) {
      let list: any = {};
      list['currentNodeID'] = value.ID;
      list['screenName'] = 'SUBJECT BREAKDOWN';
      list['childRecordStatus'] = 'ALL';
      this.service.getSubjectTree(list).subscribe(
        (i: any) => {
          if (key == 'S') {
            this.majorTopic = i;
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
          }
          if (key == 'MT') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.majorTopic = i;
            this.concept = null;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_concept = 0;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'C') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.concept = i;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC1') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept1 = i;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC2') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept2 = i;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC3') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept3 = i;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC4') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept4 = i;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC5') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept5 = i;
            this.subconcept6 = null;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC6') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept6 = i;
          }
          // }).catch((e:any)=>{
          //   this.getBreadcrumbDetails(this.SubjectParentInput.Parent_Subject_Id);
          // });
        },
        (error: any) => {
          this.getBreadcrumbDetails(this.SubjectParentInput.Parent_Subject_Id);
          console.log(error);
        }
      );
    } else {
      if (key == 'MT' && value == 0) {
        this.majorTopic = null;
        this.concept = null;
        this.subconcept1 = null;
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_majorTopic = 0;
        this.mdl_concept = 0;
        this.mdl_subconcept1 = 0;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'C' && value == 0) {
        this.concept = null;
        this.subconcept1 = null;
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_concept = 0;
        this.mdl_subconcept1 = 0;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC1' && value == 0) {
        this.subconcept1 = null;
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept1 = 0;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC2' && value == 0) {
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC3' && value == 0) {
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC4' && value == 0) {
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC5' && value == 0) {
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC6' && value == 0) {
        this.subconcept6 = null;
        this.mdl_subconcept6 = 0;
      }
    }
  }

  cancel() {
    this.cancelSubjectParentChange.emit(true);
  }

  getparentselected() {
    let parentidchanged: boolean = false;
    let currentparentid: Number = this.SubjectParentInput.Parent_Subject_Id;

    if (Number(this.mdl_subconcept6.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_subconcept6.ID
      );
    } else if (Number(this.mdl_subconcept5.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_subconcept5.ID
      );
    } else if (Number(this.mdl_subconcept4.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_subconcept4.ID
      );
    } else if (Number(this.mdl_subconcept3.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_subconcept3.ID
      );
    } else if (Number(this.mdl_subconcept2.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_subconcept2.ID
      );
    } else if (Number(this.mdl_subconcept1.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_subconcept1.ID
      );
    } else if (Number(this.mdl_concept.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(this.mdl_concept.ID);
    } else if (Number(this.mdl_majorTopic.ID > 0)) {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.mdl_majorTopic.ID
      );
    } else {
      this.SubjectParentInput.Parent_Subject_Id = Number(
        this.subject.Subject_Id
      );
    }
    if (
      Number(currentparentid) !=
      Number(this.SubjectParentInput.Parent_Subject_Id)
    ) {
      this.getBreadcrumbDetails(this.SubjectParentInput.Parent_Subject_Id);
    }
  }

  RefreshRelocate: boolean = false;
  saveSubjectElementRelocate() {
    if (!this.FromWhichComponent) {
      this.service
        .checkAndUpdateSubjectrelocate({
          Subject_Id: Number(this.SubjectParentInput.Subject_Id),
          Parent_Subject_Id: Number(this.SubjectParentInput.Parent_Subject_Id),
        })
        .subscribe(
          (res: any) => {
            // let resp:any;
            // try{resp=res.json();}catch{let resp=res;}

            if (res.Message == 'Success') {
              this.toast.success(res.Message);
              this.cancel();
              this.RefreshRelocate = true;
              this.closeAddEditElement.emit(this.RefreshRelocate);
              //  this.getsubjectDataRefresh(this.Refresh);
            } else if (res.Message == 'NotAcceptable') {
              this.toast.error('Relocate Subject Element Failed');
            } else if (res.Message == 'NotFound') {
              this.toast.error('Subject Not Found');
            } else {
              this.toast.error('Error occured,Try again');
            }
          },
          (error: any) => {
            this.onSubjectParentChangeSucces.emit(true);
            let exp: any = error.json();
            if (exp.status == 406) {
              this.toast.warning(exp.Message);
            } else if (exp.status == 404) {
              this.toast.warning(exp.Message);
            } else if (exp.status == 500) {
              this.toast.error('Error occured,Try again');
            } else {
              this.toast.error('Error occured,Try again');
            }
            console.log(error);
          }
        );
    } else {
      const payload = {
        ...this.StudyUnit,
        SubjectId: Number(this.SubjectParentInput.Parent_Subject_Id),
      };
      this.contentService.CreateOrModifyStudyUnit(payload).subscribe(
        (res) => {
          this.toast.success(res.Message, '', {
            timeOut: ConstantVars.ToastSucessTimeout,
          });
          this.closeAddEditElement.emit(this.RefreshRelocate);
        },
        (error: any) => {
          this.toast.success('Something Went wrong', '', {
            timeOut: ConstantVars.ToastErrorTimeout,
          });
        }
      );
    }
  }

  getBreadcrumbDetails(data: any) {
    this.service.getBreadcrumbDetails({ ID: data }).subscribe(
      (i: any) => {
        this.Breadcrumblist = i;
        // }).catch((e:any)=>{});
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getsubjectDataRefresh(data: any) {
    this.Refresh = data;
    let ID: Number = 0;
    if (this.Refresh.dataID != null) {
      ID = Number(this.Refresh.dataID);
    }
    let list: any = {};
    list['currentNodeID'] = ID;
    list['screenName'] = 'SUBJECT BREAKDOWN';
    list['childRecordStatus'] = 'ALL';
    this.service.getSubjectTree(list).subscribe(
      (i: any) => {
        if (this.Refresh.name == 'MT') {
          this.MajorTopic = i;
          this.subject.forEach((i: { ID: any }) => {
            if (Number(i.ID) === Number(ID)) {
            }
          });
        } else if (this.Refresh.name == 'C') {
          this.MajorTopic[this.Refresh.M].Data = i;
          try {
            if (Number(this.MajorTopic[this.Refresh.M].Data.length) > 0) {
              this.MajorTopic[this.Refresh.M].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC1') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[
                this.Refresh.C
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[
                this.Refresh.C
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC2') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC3') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data[this.Refresh.SC2].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC4') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data = i;
          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[
                this.Refresh.SC3
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[
                this.Refresh.SC3
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC5') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
            this.Refresh.SC4
          ].Data = i;

          try {
            if (
              Number(
                this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                  this.Refresh.SC1
                ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
                  this.Refresh.SC4
                ].Data.length
              ) > 0
            ) {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
                this.Refresh.SC4
              ].ChildNodeExistInd = 'Y';
            } else {
              this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
                this.Refresh.SC1
              ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
                this.Refresh.SC4
              ].ChildNodeExistInd = 'N';
            }
          } catch {}
        } else if (this.Refresh.name == 'SC6') {
          this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[
            this.Refresh.SC1
          ].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[
            this.Refresh.SC4
          ].Data[this.Refresh.SC5].Data = i;
        }
        //   }).catch((e:any)=>{
        //   this.subject=null;
        // }
        // )
      },
      (error) => {}
    );
  }
}
